import * as Sentry from '@sentry/nextjs';

type SentryContext = Record<string, string | number | boolean | null | undefined>;

const applyContext = (scope: Sentry.Scope, context?: SentryContext) => {
  if (!context) return;
  Object.entries(context).forEach(([key, value]) => {
    if (value !== undefined) {
      scope.setExtra(key, value);
    }
  });
};

export const captureAppException = (error: unknown, context?: SentryContext) => {
  Sentry.withScope((scope) => {
    applyContext(scope, context);
    Sentry.captureException(error);
  });
};

export const captureAppMessage = (
  message: string,
  level: Sentry.SeverityLevel = 'warning',
  context?: SentryContext
) => {
  Sentry.withScope((scope) => {
    scope.setLevel(level);
    applyContext(scope, context);
    Sentry.captureMessage(message);
  });
};

export const getHttpErrorContext = (error: unknown): SentryContext => {
  const err = error as { response?: { status?: number; data?: unknown }; message?: string };
  return {
    status: err?.response?.status,
    responseData: err?.response?.data ? JSON.stringify(err.response.data) : undefined,
    message: err?.message,
  };
};
